
import { RichText } from '@wordpress/block-editor';
import icons from '../../../options/icons';
import BlockContext from "../context/blockContext";
import SectionItemContext from "../context/sectionItemContext";
import { useContext } from "@wordpress/element";

const Hobbies = () => {
    const { updateField } = useContext(BlockContext);
    const { item, index, itemIndex } = useContext(SectionItemContext);
    return (
    <div className="cv-hobby">
        {item.icon && icons[item.icon] && (
        <span className="icon">{icons[item.icon]}</span>
        )}
        <RichText
        tagName="span"
        className="hobby-name"
        value={item.name}
        onChange={(value) => updateField(index, "name", value, itemIndex)}
        />
    </div>
  )
}

export default Hobbies
